import 'react';
import { css } from 'reakit/styled';
import { theme, palette } from 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import space from '../styled/space.js';
import styled from '../styled/index.js';
import '../chunk-ad6ad343.js';
import { darken } from 'polished';
import _defaultPalette from '../default/palette.js';
import _Button from 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import { a as Icon } from '../chunk-16546651.js';
import '../Set/styled.js';
import Set from '../Set/index.js';

var defaultPalette = _defaultPalette({});

var isInteractive = function isInteractive(props) {
  return !props.isStatic && !props.isLoading && !props.disabled && props.kind !== 'link';
};

var sizeProperties = {
  small: css(["&{font-size:", "em;min-height:", "em;padding:0 ", "rem;}&{", ";}"], theme('fannypack.fontSizes.100'), space(8), space(2), theme('fannypack.Button.sizes.small')),
  default: css(["&{", ";}"], theme('fannypack.Button.sizes.default')),
  medium: css(["&{min-height:", "em;padding:0 ", "rem;}&{", ";}"], space(12), space(5), theme('fannypack.Button.sizes.medium')),
  large: css(["&{font-size:", "em;min-height:", "em;padding:0 ", "rem;}&{", ";}"], theme('fannypack.fontSizes.300'), space(12), space(6), theme('fannypack.Button.sizes.large'))
};
var linkProperties = css(["&{border:0;background:unset;color:", ";fill:", ";text-decoration:underline;&:hover{color:", ";fill:", ";}}&{", ";}"], function (props // @ts-ignore
) {
  return props.palette === 'default' ? palette('text', 0, defaultPalette.text)(props) : palette()(props);
}, function (props // @ts-ignore
) {
  return props.palette === 'default' ? palette('text', 0, defaultPalette.text)(props) : palette()(props);
}, function (props) {
  return props.palette === 'default' ? // @ts-ignore
  darken(0.5, palette('text', 0, defaultPalette.text)(props)) : darken(0.5, palette()(props));
}, function (props) {
  return props.palette === 'default' ? // @ts-ignore
  darken(0.5, palette('text', 0, defaultPalette.text)(props)) : darken(0.5, palette()(props));
}, theme('fannypack.Button.link'));
var outlinedProperties = css(["&{background-color:unset;border:1px solid ", ";color:", ";fill:", ";", ";}&{", ";}"], palette(), palette(), palette(), function (props) {
  return isInteractive(props) && css(["&:hover{background-color:", ";color:", ";fill:", ";}"], palette(), function (props) {
    return palette(props.palette + "Inverted")(props);
  }, function (props) {
    return palette(props.palette + "Inverted")(props);
  });
}, theme('fannypack.Button.outlined'));
var ghostProperties = css(["&{background-color:unset;border:unset;color:", ";fill:", ";&:hover{background-color:", ";}&:hover:active{background-color:", ";}}&{", ";}"], function (props) {
  return props.palette === 'default' ? palette('defaultInverted') : palette();
}, function (props) {
  return props.palette === 'default' ? palette('defaultInverted') : palette();
}, function (props) {
  return darken(0.05, palette('default')(props));
}, function (props) {
  return darken(0.1, palette('default')(props));
}, theme('fannypack.Button.ghost'));
var disabledProperties = css(["&{cursor:not-allowed;opacity:0.7;outline:unset;pointer-events:unset;}&{", ";}"], theme('fannypack.Button.disabled'));
var staticProperties = css(["&{cursor:default;outline:unset;&:focus{box-shadow:unset !important;outline:unset !important;}}&{", ";}"], theme('fannypack.Button.static'));
var interactiveProperties = css(["&:hover{background-color:", ";}&:hover:active{background-color:", ";}&{", ";}"], function (props) {
  return darken(0.05, palette()(props));
}, function (props) {
  return darken(0.1, palette()(props));
}, theme('fannypack.Button.interactive'));
var loadingProperties = css(["&{cursor:not-allowed;position:relative;&:focus{box-shadow:unset !important;outline:unset !important;}}&{", ";}"], theme('fannypack.Button.loading'));
var ButtonIcon = styled(Icon).withConfig({
  displayName: "styled__ButtonIcon",
  componentId: "sc-1syi5vl-0"
})(["", ";", ";&{", ";}"], function (props) {
  return props.isBefore && css(["margin-left:-", "em;margin-right:", "em;"], space(1), space(2));
}, function (props) {
  return props.isAfter && css(["margin-left:", "em;margin-right:-", "em;"], space(2), space(1));
}, theme('fannypack.Button.Icon.base'));
var ActionButtons = styled(Set).withConfig({
  displayName: "styled__ActionButtons",
  componentId: "sc-1syi5vl-1"
})(["&{", ";}"], theme('fannypack.ActionButtons.base'));
var Button = styled(_Button).withConfig({
  displayName: "styled__Button",
  componentId: "sc-1syi5vl-2"
})(["align-items:center;background-color:", ";border-radius:4px;color:", ";fill:", ";cursor:pointer;display:inline-flex;font-weight:", ";min-height:2.5em;justify-content:center;padding:0 0.8rem;text-decoration:none;hyphens:auto;&:focus{outline:unset;z-index:2;box-shadow:", " 0px 0px 0px 2px;}&[disabled]{", ";}&{", ";}", ";&{", ";}", ";", ";", ";", ";", ";", ";", ";"], palette(), function (props) {
  return palette(props.palette + "Inverted")(props);
}, function (props) {
  return palette(props.palette + "Inverted")(props);
}, theme('fannypack.fontWeights.semibold'), function (props) {
  return palette(props.palette === 'default' ? 'primary' : props.palette + "300")(props);
}, disabledProperties, theme('fannypack.Button.base'), function (props) {
  return props.palette === 'default' && css(["border:1px solid ", ";"], palette('gray100'));
}, theme('fannypack.Button.base'), function (props) {
  return props.styledSize && sizeProperties[props.styledSize || ''];
}, function (props) {
  return props.isLoading && loadingProperties;
}, function (props) {
  return props.isStatic && staticProperties;
}, function (props) {
  return isInteractive(props) ? interactiveProperties : '';
}, function (props) {
  return props.kind === 'outlined' && outlinedProperties;
}, function (props) {
  return props.kind === 'link' && linkProperties;
}, function (props) {
  return props.kind === 'ghost' && ghostProperties;
});
export default Button;
export { ActionButtons, Button, ButtonIcon, disabledProperties, ghostProperties, interactiveProperties, isInteractive, linkProperties, loadingProperties, outlinedProperties, sizeProperties, staticProperties };